<template>
  <div id="designer">
    <designer-base
      :branch-types="branchTypes"
      :evaluation="evaluation"
      @cancel="onCancel"
      @save="onSave"
    />
  </div>
</template>

<script>
import DesignerBase from '@/modules/designer/designer-base'
import DesignerGuards from '@/guards/designer.guards'

export default {
  components: {
    DesignerBase
  },
  data () {
    return {
      evaluation: {}
    }
  },
  computed: {
    branchTypes () {
      return this.$store.getters['branchTypes/items']
    },
    layout () {
      return this.$store.getters['layouts/item']
    }
  },
  mounted () {
    this.evaluation = this.$store.getters['layouts/item']
  },
  methods: {
    onCancel () {
      this.$router.push({ name: 'layouts' })
    },
    onSave () {
      let loader = this.$loading()
      this.$store
        .dispatch('layouts/save', this.evaluation)
        .then(result => {
          this.$message.success('¡Se ha guardado la evaluación con éxito!')
        })
        .catch(() => {
          this.$notify.error({
            title: 'Error al guardar la evaluación',
            text: 'Por favor revise la evaluación e intente nuevamente'
          })
        })
        .finally(() => {
          loader.close()
        })
    }
  },
  beforeRouteEnter: DesignerGuards.onQuery,
  beforeRouteUpdate: DesignerGuards.onQuery
}
</script>

<style>
#designer {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: #f0f0f0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/designer/designer-view.vue